export var LEGACY_URL='/checkout_legacy';export var FETCH_CHECKOUT_URL_TIMEOUT=12000;// 12 seconds timeout for fetching a checkout url.
export var SUCCESS_CHECKOUT='SUCCESS_CHECKOUT';